import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    maxWidth: 250,
    minWidth: 200,
    padding: 0,
  },
  media: {
    borderBottomLeftRadius: theme.shape.borderRadius * 2,
    borderBottomRightRadius: theme.shape.borderRadius * 2,
    height: 90,
  },
  content: {
    padding: theme.spacing(1),
  },
  title: {
    fontSize: 12,
  },
  text: {
    color: theme.palette.primary.main,
    fontSize: 12,
  },
  cutText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  chip: {
    color: theme.palette.common.white,
    fontSize: 12,
    height: 20,
  },
}));
